import React from "react";
import { Link } from "react-router-dom";
import jewellery_1 from "../../../assets/images/home_page_5/jewellery/01.png";
import jewellery_2 from "../../../assets/images/home_page_5/jewellery/02.png";
import jewellery_3 from "../../../assets/images/home_page_5/jewellery/03.png";
import jewellery_4 from "../../../assets/images/home_page_5/jewellery/04.png";

const jewelleryItems = [
    {
        id: 1,
        title: "Bridal Jewellery",
        img: jewellery_1,
        description: "Ecology is crucial for our understanding of the natural world, and is becoming.",
    },
    {
        id: 2,
        title: "Antique Jewellery",
        img: jewellery_2,
        description: "Natural world, and is becoming increasingly important as human activities.",
    },
    {
        id: 3,
        title: "Fashion Jewellery",
        img: jewellery_3,
        description: "Such as field observations, experiments, and modeling, to study the complex.",
    },
    {
        id: 4,
        title: "Designed Pendant",
        img: jewellery_4,
        description: "The goal of ecology is to understand how organisms interact with each other.",
    },
];

const Jewellery = () => {
    return (
        <section id="jewellery" className="jewellery-main-block">
            <div className="container">
                <div className="row">
                    {jewelleryItems.map((item) => (
                        <div key={item.id} className="col-lg-3 col-md-6">
                            <div className="jewellery-block text-center">
                                <div className="jewellery-img">
                                    <img src={item.img} className="img-fluid" alt={item.title} />
                                </div>
                                <div className="jewellery-dtl">
                                    <h6 className="jewellery-title">{item.title}</h6>
                                    <p>{item.description}</p>
                                    <Link to="#" title="" className="btn btn-secondary">
                                        Read More <i className="flaticon-right-arrow-1" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Jewellery;
